import axios from './axios';
import { Ticket, TicketCreate, TicketUpdate, TicketList, TicketResponse } from '../types/ticket';

const TICKETS_URL = '/tickets';

export const ticketsApi = {
  // Create ticket with form data and attachments
  createTicket: async (ticketData: TicketCreate, attachments: File[] = []): Promise<TicketResponse> => {
    const formData = new FormData();
    
    // Add ticket fields
    formData.append('user_email', ticketData.user_email);
    formData.append('user_name', ticketData.user_name);
    formData.append('subject', ticketData.subject);
    formData.append('description', ticketData.description);
    formData.append('is_logged_in_user', ticketData.is_logged_in_user.toString());
    
    if (ticketData.captcha_token) {
      formData.append('captcha_token', ticketData.captcha_token);
    }
    
    // Add attachments
    attachments.forEach((file) => {
      formData.append('attachments', file);
    });
    
    const response = await axios.post<TicketResponse>(TICKETS_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  },

  // Get tickets with optional filtering
  getTickets: async (params?: {
    skip?: number;
    limit?: number;
    status?: 'open' | 'in_progress' | 'closed';
    user_email?: string;
  }): Promise<TicketList> => {
    const response = await axios.get<TicketList>(TICKETS_URL, { params });
    return response.data;
  },

  // Get ticket by ID
  getTicket: async (ticketId: number): Promise<Ticket> => {
    const response = await axios.get<Ticket>(`${TICKETS_URL}/${ticketId}`);
    return response.data;
  },

  // Get ticket by number
  getTicketByNumber: async (ticketNumber: string): Promise<Ticket> => {
    const response = await axios.get<Ticket>(`${TICKETS_URL}/number/${ticketNumber}`);
    return response.data;
  },

  // Update ticket
  updateTicket: async (ticketId: number, ticketUpdate: TicketUpdate): Promise<Ticket> => {
    const response = await axios.put<Ticket>(`${TICKETS_URL}/${ticketId}`, ticketUpdate);
    return response.data;
  },

  // Delete ticket (soft delete)
  deleteTicket: async (ticketId: number): Promise<TicketResponse> => {
    const response = await axios.delete<TicketResponse>(`${TICKETS_URL}/${ticketId}`);
    return response.data;
  },

  // Get ticket attachments
  getTicketAttachments: async (ticketId: number) => {
    const response = await axios.get(`${TICKETS_URL}/${ticketId}/attachments`);
    return response.data;
  },

  // Delete ticket attachment
  deleteTicketAttachment: async (attachmentId: number) => {
    const response = await axios.delete(`${TICKETS_URL}/attachments/${attachmentId}`);
    return response.data;
  },
};
